import { containerSelectors } from './container.selector'

export const ContainerComponent = (() => {
	const getContainer = (value: string) => containerSelectors.getContainer(value)

	return {
		getContainer,
	}
})()
